// ROUM-PDFEDITOR-FEAT-20260620
import { useState, useEffect, useRef, useCallback } from "react";
import * as api from "./api";
import { Svg, Toast, G, A, ALt, OK, E, ELt, P, iX, iSave, iTrash, iCheck, iPlus } from "./shared";
import { getSavedStamps, saveStamp, renameStamp, deleteStamp } from './stampStore';

/* ── 상수 ── */
var THUMB_SCALE = 0.25;
var CANVAS_MAX_W = 800;
var PEN_COLORS = ["#000", "#1E40AF", "#DC2626"];
var SIGN_FONTS = [
  { name: 'Nanum Pen Script', family: "'Nanum Pen Script', cursive" },
  { name: 'Nanum Brush Script', family: "'Nanum Brush Script', cursive" },
  { name: 'Gaegu', family: "'Gaegu', cursive" },
  { name: 'Hi Melody', family: "'Hi Melody', cursive" },
  { name: 'Single Day', family: "'Single Day', cursive" },
  { name: 'Yeon Sung', family: "'Yeon Sung', cursive" },
  { name: '나눔 엉겅퀴', family: "'NanumUnggeongkwi', cursive" },
  { name: '나눔 여름글씨', family: "'NanumYeoreum', cursive" },
  { name: 'KCC 임권택', family: "'KCC Imkwontaek', cursive" },
  { name: '박용준체', family: "'Pak Yong Jun', cursive" },
  { name: '그리운 공정', family: "'Griun Fairness', cursive" },
  { name: '그리운 인권', family: "'Griun Humanrights', cursive" },
];
var FONT_STYLES = SIGN_FONTS.map(function(f) {
  return { family: f.family, weight: "400", style: "normal", label: f.name };
});
var LS_PREFIX = "pdf_edit_";

/* ── 헬퍼 ── */
function uid() { return Math.random().toString(36).slice(2, 10); }
function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

function renderTextToCanvas(text, font, size, color) {
  var scale = 2;
  var cvs = document.createElement("canvas");
  var ctx = cvs.getContext("2d");
  ctx.font = font.style + " " + font.weight + " " + (size * scale) + "px " + font.family;
  var m = ctx.measureText(text);
  cvs.width = Math.ceil(m.width * 1.3) + 40 * scale;
  cvs.height = (size + 40) * scale;
  ctx.fillStyle = color || "#000";
  ctx.textBaseline = "middle";
  var cx = 15 * scale;
  for (var i = 0; i < text.length; i++) {
    var charSize = (size + (Math.random() - 0.5) * size * 0.30) * scale;
    ctx.font = font.style + " " + font.weight + " " + charSize + "px " + font.family;
    var oy = (Math.random() - 0.5) * size * scale * 0.40;
    var angle = (Math.random() - 0.5) * 0.30;
    var sx = 0.85 + Math.random() * 0.30;
    ctx.save();
    ctx.translate(cx, cvs.height / 2 + oy);
    ctx.rotate(angle);
    ctx.scale(sx, 1);
    ctx.fillText(text[i], 0, 0);
    ctx.restore();
    cx += ctx.measureText(text[i]).width * sx + (Math.random() - 0.5) * 6 * scale;
  }
  return cvs.toDataURL("image/png");
}

function renderStampSVG(name, style) {
  var s = style || 0;
  var c = '#CC0000';
  var dn = name || '이름';
  var chars = dn.split('');
  var len = chars.length;
  var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 200 200">';

  if (s === 0) {
    svg += '<circle cx="100" cy="100" r="90" fill="none" stroke="' + c + '" stroke-width="5"/>';
    var fs0 = len === 1 ? 100 : len === 2 ? 68 : len === 3 ? 48 : 36;
    svg += '<text x="100" y="104" text-anchor="middle" font-size="' + fs0 + '" fill="' + c + '" font-family="serif" font-weight="900" dominant-baseline="middle">' + dn + '</text>';
  } else if (s === 1) {
    svg += '<ellipse cx="100" cy="100" rx="48" ry="88" fill="none" stroke="' + c + '" stroke-width="5"/>';
    svg += '<ellipse cx="100" cy="100" rx="40" ry="80" fill="none" stroke="' + c + '" stroke-width="2"/>';
    var gap1 = len <= 2 ? 44 : len === 3 ? 38 : 28;
    var sy1 = 100 - (len - 1) * gap1 / 2;
    for (var i1 = 0; i1 < len; i1++) {
      svg += '<text x="100" y="' + (sy1 + i1 * gap1) + '" text-anchor="middle" font-size="34" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + chars[i1] + '</text>';
    }
  } else if (s === 2) {
    svg += '<ellipse cx="100" cy="100" rx="66" ry="90" fill="none" stroke="' + c + '" stroke-width="5"/>';
    svg += '<ellipse cx="100" cy="100" rx="57" ry="81" fill="none" stroke="' + c + '" stroke-width="2"/>';
    var h2 = Math.ceil(len / 2);
    var top2 = dn.substring(0, h2), bot2 = dn.substring(h2);
    if (bot2) {
      svg += '<text x="100" y="83" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + top2 + '</text>';
      svg += '<text x="100" y="120" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + bot2 + '</text>';
    } else {
      svg += '<text x="100" y="103" text-anchor="middle" font-size="38" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + dn + '</text>';
    }
  } else if (s === 3) {
    svg += '<circle cx="100" cy="100" r="90" fill="none" stroke="' + c + '" stroke-width="5"/>';
    svg += '<circle cx="100" cy="100" r="76" fill="none" stroke="' + c + '" stroke-width="2"/>';
    svg += '<defs><path id="bArc3" d="M 24 100 A 76 76 0 0 0 176 100" fill="none"/></defs>';
    var fs3 = len > 5 ? 16 : len > 3 ? 20 : 24;
    svg += '<text font-size="' + fs3 + '" fill="' + c + '" font-family="serif" font-weight="bold"><textPath href="#bArc3" startOffset="50%" text-anchor="middle">' + dn + '</textPath></text>';
    svg += '<text x="100" y="92" text-anchor="middle" font-size="48" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">印</text>';
  } else if (s === 4) {
    svg += '<rect x="18" y="32" width="164" height="136" fill="none" stroke="' + c + '" stroke-width="6" rx="2"/>';
    svg += '<rect x="30" y="44" width="140" height="112" fill="none" stroke="' + c + '" stroke-width="2" rx="1"/>';
    var h4 = Math.ceil(len / 2);
    var t4 = dn.substring(0, h4), b4 = dn.substring(h4);
    if (b4) {
      svg += '<text x="100" y="85" text-anchor="middle" font-size="38" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + t4 + '</text>';
      svg += '<text x="100" y="128" text-anchor="middle" font-size="38" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + b4 + '</text>';
    } else {
      svg += '<text x="100" y="106" text-anchor="middle" font-size="44" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + dn + '</text>';
    }
  } else if (s === 5) {
    svg += '<rect x="14" y="22" width="172" height="156" fill="none" stroke="' + c + '" stroke-width="6" rx="2"/>';
    svg += '<rect x="24" y="32" width="152" height="136" fill="none" stroke="' + c + '" stroke-width="2" rx="1"/>';
    svg += '<line x1="24" y1="105" x2="176" y2="105" stroke="' + c + '" stroke-width="2"/>';
    var fs5 = len > 5 ? 22 : len > 3 ? 28 : 34;
    svg += '<text x="100" y="70" text-anchor="middle" font-size="' + fs5 + '" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + dn + '</text>';
    svg += '<text x="100" y="138" text-anchor="middle" font-size="30" fill="' + c + '" font-family="serif" dominant-baseline="middle">印</text>';
  } else if (s === 6) {
    svg += '<ellipse cx="100" cy="100" rx="54" ry="90" fill="none" stroke="' + c + '" stroke-width="5"/>';
    var gap6 = len <= 3 ? 36 : 28;
    var sy6 = 92 - (len - 1) * gap6 / 2;
    for (var j6 = 0; j6 < len; j6++) {
      svg += '<text x="100" y="' + (sy6 + j6 * gap6) + '" text-anchor="middle" font-size="30" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + chars[j6] + '</text>';
    }
    svg += '<text x="100" y="168" text-anchor="middle" font-size="20" fill="' + c + '" font-family="serif" dominant-baseline="middle">印</text>';
  } else {
    svg += '<rect x="10" y="10" width="180" height="180" fill="none" stroke="' + c + '" stroke-width="6" rx="2"/>';
    svg += '<rect x="22" y="22" width="156" height="156" fill="none" stroke="' + c + '" stroke-width="2" rx="1"/>';
    svg += '<rect x="34" y="34" width="132" height="132" fill="none" stroke="' + c + '" stroke-width="1.5" rx="1"/>';
    var h7 = Math.ceil(len / 2);
    var t7 = dn.substring(0, h7), b7 = dn.substring(h7);
    if (b7) {
      svg += '<text x="100" y="83" text-anchor="middle" font-size="36" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + t7 + '</text>';
      svg += '<text x="100" y="122" text-anchor="middle" font-size="36" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline ="middle">' + b7 + '</text>';
    } else {
      svg += '<text x="100" y="103" text-anchor="middle" font-size="40" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">' + dn + '</text>';
    }
  }
  svg += '</svg>';
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

function renderCorpStamp(name, style) {
  var s = style || 0;
  var c = '#CC0000';
  var dn = name || '주식회슬';
  var len = dn.length;
  var fs = len > 10 ? 11 : len > 8 ? 13 : len > 6 ? 15 : len > 4 ? 17 : 20;
  var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 200 200">';

  function circles(r1, r2, w1, w2) {
    return '<circle cx="100" cy="100" r="' + r1 + '" fill="none" stroke="' + c + '" stroke-width="' + w1 + '"/>' +
           '<circle cx="100" cy="100" r="' + r2 + '" fill="none" stroke="' + c + '" stroke-width="' + w2 + '"/>';
  }
  function topArc(arcR, uid) {
    var lx = 100 - arcR, rx2 = 100 + arcR;
    return '<defs><path id="' + uid + '" d="M ' + lx + ' 100 A ' + arcR + ' ' + arcR + ' 0 0 1 ' + rx2 + ' 100" fill="none"/></defs>' +
          '<text font-size="' + fs + '" fill="' + c + '" font-family="serif" font-weight="bold"><textPath href="#' + uid + '" startOffset="50%" text-anchor="middle">' + dn + '</textPath></text>';
  }
  function ctr(y1, y2, cfs) {
    return '<text x="100" y="' + y1 + '" text-anchor="middle" font-size="' + cfs + '" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">대표</text>' +
          '<text x="100" y="' + y2 + '" text-anchor="middle" font-size="' + cfs + '" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">이사</text>';
  }

  if (s === 0) {
    svg += circles(90, 75, 6, 2) + topArc(82, 'ta0') + ctr(88, 120, 32);
    svg += '<text x="100" y="28" text-anchor="middle" font-size="18" fill="' + c + '" dominant-baseline="middle">⊥</text>';
    svg += '<circle cx="14" cy="100" r="5" fill="' + c + '"/><circle cx="186" cy="100" r="5" fill="' + c + '"/>';
  } else if (s === 1) {
    svg += '<circle cx="100" cy="100" r="90" fill="none" stroke="' + c + '" stroke-width="6"/>';
    svg += '<circle cx="100" cy="100" r="80" fill="none" stroke="' + c + '" stroke-width="1.5"/>';
    svg += '<circle cx="100" cy="100" r="74" fill="none" stroke="' + c + '" stroke-width="2.5"/>';
    svg += topArc(77, 'ta1') + ctr(88, 120, 32);
    svg += '<circle cx="100" cy="15" r="5" fill="' + c + '"/>';
  } else if (s === 2) {
    svg += circles(90, 75, 6, 2) + topArc(82, 'ta2');
    svg += '<text x="100" y="85" text-anchor="middle" font-size="38" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">焆</text>';
    svg += '<text x="100" y="126" text-anchor="middle" font-size="38" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">事</text>';
  } else if (s === 3) {
    svg += circles(90, 75, 6, 2) + topArc(82, 'ta3');
    svg += '<text x="100" y="65" text-anchor="middle" font-size="20" fill="' + c + '" dominant-baseline="middle">★</text>';
    svg += '<text x="100" y="95" text-anchor="middle" font-size="34" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">理</text>';
    svg += '<text x="100" y="130" text-anchor="middle" font-size="34" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">事</text>';
  } else if (s === 4) {
    svg += '<circle cx="100" cy="100" r="90" fill="none" stroke="' + c + '" stroke-width="8"/>';
    svg += '<circle cx="100" cy="100" r="76" fill="none" stroke="' + c + '" stroke-width="2"/>';
    svg += topArc(83, 'ta4') + ctr(88, 120, 34);
  } else if (s === 5) {
    svg += circles(90, 75, 6, 2) + topArc(82, 'ta5') + ctr(88, 120, 32);
    svg += '<circle cx="100" cy="14" r="5" fill="' + c + '"/><circle cx="100" cy="186" r="5" fill="' + c + '"/>';
    svg += '<circle cx="14" cy="100" r="5" fill="' + c + '"/><circle cx="186" cy="100" r="5" fill="' + c + '"/>';
  } else if (s === 6) {
    svg += circles(90, 75, 6, 2) + topArc(82, 'ta6');
    svg += '<text x="70" y="90" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">대 </text>';
    svg += '<text x="130" y="90" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">이</text>';
    svg += '<text x="70" y="124" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">표</text>';
    svg += '<text x="130" y="124" text-anchor="middle" font-size="32" fill="' + c + '" font-family="serif" font-weight="bold" dominant-baseline="middle">사</text>';
  } else {
    svg += circles(90, 75, 6, 2);
    svg += '<line x1="100" y1="26" x2="100" y2="75" stroke="' + c + '" stroke-width="1.5"/>';
    svg += '<line x1="26" y1="100" x2="75" y2="100" stroke="' + c + '" stroke-width="1.5"/>';
    svg += '<line x1="125" y1="100" x2="174" y2="100" stroke="' + c + '" stroke-width="1.5"/>';
    svg += '<line x1="100" y1="125" x2="100" y2="174" stroke="' + c + '" stroke-width="1.5"/>';
    svg += topArc(82, 'ta7') + ctr(88, 120, 30);
  }
  svg += '</svg>';
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}


/* ROUM-PDFEDITOR-RULER-20260621
 * 페이지 상/하/좌/우 눈금자(자). 페이지 래퍼(position:relative) 안에 % 기준 오버레이로 그려
 * 줌·페이지 무관하게 정렬되고, pointerEvents:none 이라 배치/클릭에 영향 없음.
 * export는 요소를 캔버스에 재구성하므로 이 DOM 눈금은 다운로드 PDF에 포함되지 않음. */
function RulerOverlay() {
  var TH = 15, GAP = 2;
  var BG = "rgba(249,250,251,0.95)", BD = "#D1D5DB", TICK = "#9CA3AF", MAJ = "#6B7280", LBL = "#6B7280";
  var marks = [];
  for (var i = 0; i <= 100; i += 5) marks.push(i);
  function strip(orient) {
    var horizontal = (orient === "top" || orient === "bottom");
    var box = { position: "absolute", background: BG, boxSizing: "border-box" };
    if (orient === "top") { box.left = 0; box.right = 0; box.top = -(TH + GAP); box.height = TH; box.borderBottom = "1px solid " + BD; }
    if (orient === "bottom") { box.left = 0; box.right = 0; box.bottom = -(TH + GAP); box.height = TH; box.borderTop = "1px solid " + BD; }
    if (orient === "left") { box.top = 0; box.bottom = 0; box.left = -(TH + GAP); box.width = TH; box.borderRight = "1px solid " + BD; }
    if (orient === "right") { box.top = 0; box.bottom = 0; box.right = -(TH + GAP); box.width = TH; box.borderLeft = "1px solid " + BD; }
    return (
      <div key={orient} style={box}>
        {marks.map(function(v) {
          var major = (v % 10 === 0);
          var tlen = major ? 7 : 4;
          var tick = { position: "absolute", background: major ? MAJ : TICK };
          var lbl = { position: "absolute", fontSize: 7, color: LBL, lineHeight: 1, fontFamily: "system-ui,sans-serif" };
          if (horizontal) {
            tick.left = v + "%"; tick.width = 1; tick.height = tlen;
            tick.top = (orient === "top") ? (TH - tlen) : 0;
            lbl.left = "calc(" + v + "% + 1.5px)";
            if (orient === "top") { lbl.top = 1; } else { lbl.bottom = 1; }
          } else {
            tick.top = v + "%"; tick.height = 1; tick.width = tlen;
            tick.left = (orient === "left") ? (TH - tlen) : 0;
            lbl.top = "calc(" + v + "% + 1px)";
            if (orient === "left") { lbl.left = 1; } else { lbl.right = 1; }
          }
          return (
            <div key={orient + "-" + v}>
              <div style={tick} />
              {major && v !== 0 && v !== 100 && <span style={lbl}>{v}</span>}
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <div style={{ position: "absolute", left: 0, top: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 6 }}>
      {strip("top")}{strip("bottom")}{strip("left")}{strip("right")}
    </div>
  );
}

export default function PdfEditor(props) {
  var uploadId = props.uploadId;
  var fileUrl = props.fileUrl;
  var onClose = props.onClose;
  var onSaved = props.onSaved;
  var onSaveBlob = props.onSaveBlob; // 제공 시: 다운로드 대신 결과 PDF blob을 콜백으로 전달(파일에 되돌리기)
  var hideScan = props.hideScan; // true 시: '스캔본 다운로드' 버튼 숨김 (발행등기 사채서류 서명 등 스캔효과 금지 단계)

  /* ── 상태 ── */
  var [loading, setLoading] = useState(false);
  var [saving, setSaving] = useState(false);
  var [toast, setToast] = useState("");
  var [pdfUrl, setPdfUrl] = useState(null);
  var [fileName, setFileName] = useState('');
  var [pageCount, setPageCount] = useState(0);
  var [pages, setPages] = useState([]); // [{origIdx, rotation, deleted}]
  var [curPage, setCurPage] = useState(0);
  var [pageImages, setPageImages] = useState({});
  var [elements, setElements] = useState({}); // {pageIdx: [{id,type,x,y,w,h,src,text}]}
  var [selectedEl, setSelectedEl] = useState(null);
  var [tool, setTool] = useState(null); // null|'text'|'check'|'signature'|'stamp'
  var [showSigModal, setShowSigModal] = useState(false);
  var [showStampModal, setShowStampModal] = useState(false);
  var [hasChanges, setHasChanges] = useState(false);
  var [dragEl, setDragEl] = useState(null);
  var [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  var [resizeEl, setResizeEl] = useState(null);
  var [resizeStart, setResizeStart] = useState(null);
  var [canvasSize, setCanvasSize] = useState({ w: 0, h: 0 });
  var [stripHeight, setStripHeight] = useState(110);

  var pdfRef = useRef(null);
  var canvasRef = useRef(null);
  var containerRef = useRef(null);
  var fileInputRef = useRef(null);

  function showT(m) { setToast(m); setTimeout(function() { setToast(""); }, 2500); }

  /* ── Google Fonts 로딩 ── */
  useEffect(function() {
    if (!document.getElementById('pdf-sign-fonts')) {
      var link = document.createElement('link');
      link.id = 'pdf-sign-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&family=Nanum+Brush+Script&family=Gaegu&family=Hi+Melody&family=Single+Day&family=Yeon+Sung&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  /* ── PDF 로딩 ── */
  useEffect(function() {
    if (fileUrl) {
      setPdfUrl(fileUrl);
      return;
    }
    if (!uploadId) return;
    api.getPdfInfo(uploadId).then(function() {
      var token = localStorage.getItem("token") || "";
      return fetch("/api/uploads/" + uploadId + "/pdf-proxy", {
        headers: token ? { "Authorization": "Bearer " + token } : {}
      });
    }).then(function(resp) {
      if (!resp.ok) throw new Error("PDF load fail");
      return resp.blob();
    }).then(function(blob) {
      setPdfUrl(URL.createObjectURL(blob));
    }).catch(function(e) {
      showT("PDF 로딩 실패: " + e.message);
      setTimeout(onClose, 1500);
    });
  }, [uploadId, fileUrl]);

  /* ── PDF.js 파싱 ── */
  useEffect(function() {
    if (!pdfUrl) return;
    var pdfjsLib = window.pdfjsLib;
    if (!pdfjsLib) { showT("PDF.js가 로드되지 않았습니다"); return; }
    pdfjsLib.getDocument(pdfUrl).promise.then(function(pdf) {
      pdfRef.current = pdf;
      var cnt = pdf.numPages;
      setPageCount(cnt);
      var arr = [];
      for (var i = 0; i < cnt; i++) arr.push({ origIdx: i, rotation: 0, deleted: false });
      setPages(arr);
      setLoading(false);
      // render thumbnails
      for (var j = 1; j <= cnt; j++) {
        (function(num) {
          pdf.getPage(num).then(function(page) {
            var vp = page.getViewport({ scale: THUMB_SCALE });
            var cvs = document.createElement("canvas");
            cvs.width = vp.width; cvs.height = vp.height;
            page.render({ canvasContext: cvs.getContext("2d"), viewport: vp }).promise.then(function() {
              setPageImages(function(prev) { var n = Object.assign({}, prev); n[num - 1] = cvs.toDataURL(); return n; });
            });
          });
        })(j);
      }
    }).catch(function(e) { showT("PDF 렌더링 실패"); console.error(e); });
  }, [pdfUrl]);

  /* ── localStorage 복원 ── */
  useEffect(function() {
    var key = LS_PREFIX + (uploadId || "url");
    try {
      var saved = localStorage.getItem(key);
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed.elements) setElements(parsed.elements);
      }
    } catch (e) { /* ignore */ }
  }, [uploadId]);

  /* ── localStorage 자동저장 (5초) ── */
  useEffect(function() {
    var key = LS_PREFIX + (uploadId || "url");
    var iv = setInterval(function() {
      try { localStorage.setItem(key, JSON.stringify({ elements: elements })); } catch (e) { /* */ }
    }, 5000);
    return function() { clearInterval(iv); };
  }, [elements, uploadId]);

  /* ── 메인 캔버스 렌더링 ── */
  var renderPage = useCallback(function(pageIdx) {
    var pdf = pdfRef.current;
    if (!pdf) return;
    var visPages = pages.filter(function(p) { return !p.deleted; });
    if (pageIdx >= visPages.length) return;
    var pg = visPages[pageIdx];
    pdf.getPage(pg.origIdx + 1).then(function(page) {
      var container = containerRef.current;
      if (!container) return;
      var maxW = Math.min(CANVAS_MAX_W, container.clientWidth - 40);
      var baseVp = page.getViewport({ scale: 1, rotation: pg.rotation });
      var scale = maxW / baseVp.width;
      var vp = page.getViewport({ scale: scale, rotation: pg.rotation });
      var cvs = canvasRef.current;
      if (!cvs) return;
      cvs.width = vp.width;
      cvs.height = vp.height;
      setCanvasSize({ w: vp.width, h: vp.height });
      page.render({ canvasContext: cvs.getContext("2d"), viewport: vp });
    });
  }, [pages]);

  useEffect(function() {
    if (!loading) renderPage(curPage);
  }, [curPage, loading, pages, renderPage]);

  /* ── 가시 페이지 ── */
  var visiblePages = pages.filter(function(p) { return !p.deleted; });

  /* ── 현재 페이지의 origIdx ── */
  var curOrigIdx = visiblePages.length > 0 && visiblePages[curPage] ? visiblePages[curPage].origIdx : 0;

  /* ── 현재 페이지의 요소들 ── */
  var curElements = elements[curOrigIdx] || [];

  function updateElements(origIdx, els) {
    setElements(function(prev) { var n = Object.assign({}, prev); n[origIdx] = els; return n; });
    setHasChanges(true);
  }

  /* ── 캔버스 클릭 → 도구 적용 ── */
  function handleCanvasClick(e) {
    if (!tool || tool === "signature" || tool === "stamp") { setSelectedEl(null); return; }
    var rect = canvasRef.current.getBoundingClientRect();
    var xPct = ((e.clientX - rect.left) / rect.width) * 100;
    var yPct = ((e.clientY - rect.top) / rect.height) * 100;
    var el = { id: uid(), x: xPct, y: yPct, w: 0, h: 0 };
    if (tool === "text") {
      el.type = "text";
      el.text = "";
      el.editing = true;
      el.w = 20;
      el.h = 4;
    } else if (tool === "check") {
      el.type = "check";
      el.text = "\u2713";
      el.w = 3;
      el.h = 3;
    }
    var cur = (elements[curOrigIdx] || []).slice();
    cur.push(el);
    updateElements(curOrigIdx, cur);
    setSelectedEl(el.id);
    setTool(null);
  }

  /* ── 요소 드래그 ── */
  function handleElMouseDown(e, elId) {
    e.stopPropagation();
    e.preventDefault();
    setSelectedEl(elId);
    var rect = canvasRef.current.getBoundingClientRect();
    var el = curElements.find(function(x) { return x.id === elId; });
    if (!el) return;
    setDragEl(elId);
    setDragOffset({
      x: e.clientX - rect.left - (el.x / 100) * rect.width,
      y: e.clientY - rect.top - (el.y / 100) * rect.height
    });
  }

  useEffect(function() {
    if (!dragEl) return;
    function onMove(e) {
      var rect = canvasRef.current.getBoundingClientRect();
      var xPct = clamp(((e.clientX - rect.left - dragOffset.x) / rect.width) * 100, 0, 95);
      var yPct = clamp(((e.clientY - rect.top - dragOffset.y) / rect.height) * 100, 0, 95);
      var els = (elements[curOrigIdx] || []).map(function(el) {
        return el.id === dragEl ? Object.assign({}, el, { x: xPct, y: yPct }) : el;
      });
      updateElements(curOrigIdx, els);
    }
    function onUp() { setDragEl(null); }
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    return function() { document.removeEventListener("mousemove", onMove); document.removeEventListener("mouseup", onUp); };
  }, [dragEl, dragOffset, curOrigIdx, elements]);

  /* ── 요소 리사이즈 ── */
  function handleResizeDown(e, elId) {
    e.stopPropagation();
    e.preventDefault();
    var el = curElements.find(function(x) { return x.id === elId; });
    if (!el) return;
    setResizeEl(elId);
    setResizeStart({ mx: e.clientX, my: e.clientY, w: el.w, h: el.h });
  }

  useEffect(function() {
    if (!resizeEl) return;
    function onMove(e) {
      var rect = canvasRef.current.getBoundingClientRect();
      var dxPct = ((e.clientX - resizeStart.mx) / rect.width) * 100;
      var dyPct = ((e.clientY - resizeStart.my) / rect.height) * 100;
      var nw = Math.max(2, resizeStart.w + dxPct);
      var nh = Math.max(2, resizeStart.h + dyPct);
      var els = (elements[curOrigIdx] || []).map(function(el) {
        return el.id === resizeEl ? Object.assign({}, el, { w: nw, h: nh }) : el;
      });
      updateElements(curOrigIdx, els);
    }
    function onUp() { setResizeEl(null); setResizeStart(null); }
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    return function() { document.removeEventListener("mousemove", onMove); document.removeEventListener("mouseup", onUp); };
  }, [resizeEl, resizeStart, curOrigIdx, elements]);

  /* ── Delete / Ctrl+C / Ctrl+V 키 ── */
  var clipboardRef = useRef(null);
  useEffect(function() {
    function onKey(e) {
      if (e.key === "Delete" && selectedEl) {
        var els = (elements[curOrigIdx] || []).filter(function(el) { return el.id !== selectedEl; });
        updateElements(curOrigIdx, els);
        setSelectedEl(null);
      }
      // Ctrl+C: 선택된 요소 복사
      if ((e.ctrlKey || e.metaKey) && e.key === "c" && selectedEl) {
        var found = (elements[curOrigIdx] || []).find(function(el) { return el.id === selectedEl; });
        if (found) clipboardRef.current = Object.assign({}, found);
      }
      // Ctrl+V: 붙여넣기 (약간 오프셋)
      if ((e.ctrlKey || e.metaKey) && e.key === "v" && clipboardRef.current) {
        e.preventDefault();
        var copy = Object.assign({}, clipboardRef.current, { id: uid(), x: (clipboardRef.current.x || 0) + 2, y: (clipboardRef.current.y || 0) + 2 });
        var cur = (elements[curOrigIdx] || []).slice();
        cur.push(copy);
        updateElements(curOrigIdx, cur);
        setSelectedEl(copy.id);
      }
    }
    document.addEventListener("keydown", onKey);
    return function() { document.removeEventListener("keydown", onKey); };
  }, [selectedEl, curOrigIdx, elements]);

  /* ── 서명/도장 결과 → 요소 추가 ── */
  function addImageElement(src) {
    var el = { id: uid(), type: "image", x: 30, y: 30, w: 20, h: 10, src: src, rotation: 0 };
    void handleRotateDown;
    var cur = (elements[curOrigIdx] || []).slice();
    cur.push(el);
    updateElements(curOrigIdx, cur);
    setSelectedEl(el.id);
  }

  function handleRotateDown(e, elId) {
    e.stopPropagation(); e.preventDefault();
    var box = e.currentTarget.parentNode.getBoundingClientRect();
    var cx = box.left + box.width / 2, cy = box.top + box.height / 2;
    var cur0 = (elements[curOrigIdx] || []).find(function(x) { return x.id === elId; });
    var startRot = (cur0 && cur0.rotation) || 0;
    var startAng = Math.atan2(e.clientY - cy, e.clientX - cx);
    function onMove(ev) {
      var deg = Math.round(startRot + (Math.atan2(ev.clientY - cy, ev.clientX - cx) - startAng) * 180 / Math.PI);
      if (Math.abs(deg % 90) <= 2) deg = Math.round(deg / 90) * 90;
      var els = (elements[curOrigIdx] || []).map(function(x) { return x.id === elId ? Object.assign({}, x, { rotation: deg }) : x; });
      updateElements(curOrigIdx, els);
    }
    function onUp() { window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); }
    window.addEventListener("mousemove", onMove); window.addEventListener("mouseup", onUp);
  }

  /* ── 페이지 관리 ── */
  function rotatePage(idx) {
    setPages(function(prev) {
      return prev.map(function(p, i) {
        if (i !== idx) return p;
        return Object.assign({}, p, { rotation: (p.rotation + 90) % 360 });
      });
    });
    setHasChanges(true);
    // re-render thumbnail
    var pg = pages[idx];
    if (pdfRef.current && pg) {
      pdfRef.current.getPage(pg.origIdx + 1).then(function(page) {
        var newRot = (pg.rotation + 90) % 360;
        var vp = page.getViewport({ scale: THUMB_SCALE, rotation: newRot });
        var cvs = document.createElement("canvas");
        cvs.width = vp.width; cvs.height = vp.height;
        page.render({ canvasContext: cvs.getContext("2d"), viewport: vp }).promise.then(function() {
          setPageImages(function(prev) { var n = Object.assign({}, prev); n[pg.origIdx] = cvs.toDataURL(); return n; });
        });
      });
    }
  }

  function deletePage(origIdx) {
    if (visiblePages.length <= 1) { showT("최소 1페이지 필요"); return; }
    setPages(function(prev) {
      return prev.map(function(p) { return p.origIdx === origIdx ? Object.assign({}, p, { deleted: true }) : p; });
    });
    if (curPage >= visiblePages.length - 1) setCurPage(Math.max(0, curPage - 1));
    setHasChanges(true);
  }

  /* ── 정리모드 드래그 ── */
  var [thumbDrag, setThumbDrag] = useState(null);
  var [thumbOver, setThumbOver] = useState(null);

  function handleThumbDrop(toVi) {
    if (thumbDrag === null || thumbDrag === toVi) { setThumbDrag(null); setThumbOver(null); return; }
    var vis = pages.filter(function(p) { return !p.deleted; });
    var moved = vis[thumbDrag];
    var target = vis[toVi];
    var arr = pages.slice();
    var fi = arr.indexOf(moved);
    arr.splice(fi, 1);
    var ti = arr.indexOf(target);
    if (thumbDrag < toVi) ti++;
    arr.splice(ti, 0, moved);
    setPages(arr);
    setThumbDrag(null);
    setThumbOver(null);
    setHasChanges(true);
  }

  /* ── PDF 파일 열기 ── */
  function handleOpenPdf(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    var blobUrl = URL.createObjectURL(file);
    setPdfUrl(blobUrl);
    setLoading(true);
    setPages([]);
    setPageImages({});
    setElements({});
    setSelectedEl(null);
    setCurPage(0);
    setHasChanges(false);
    e.target.value = "";
  }

  function applyScanEffect(cvs) {
    var ctx = cvs.getContext("2d"), w = cvs.width, h = cvs.height;
    var tmp = document.createElement("canvas"); tmp.width = w; tmp.height = h;
    tmp.getContext("2d").drawImage(cvs, 0, 0);
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = "#fbfbf7"; ctx.fillRect(0, 0, w, h);
    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate((Math.random() * 2 - 1) * 0.5 * Math.PI / 180);
    ctx.filter = "contrast(1.08) brightness(0.99)";
    ctx.drawImage(tmp, -w / 2, -h / 2);
    ctx.restore(); ctx.filter = "none";
    var id = ctx.getImageData(0, 0, w, h), d = id.data;
    for (var i = 0; i < d.length; i += 4) {
      var nz = (Math.random() * 2 - 1) * 13;
      d[i] += nz; d[i + 1] += nz; d[i + 2] += nz;
    }
    ctx.putImageData(id, 0, 0);
    tmp.width = 0; tmp.height = 0;
  }

  /* ── 저장 (오버레이 합성) ── */
  async function handleSave(scanFx) {
    if (!pdfUrl) return;
    setSaving(true);
    try {
      var pdfDoc = await window.pdfjsLib.getDocument(pdfUrl).promise;
      var vis = pages.filter(function(p) { return !p.deleted; });
      var blobs = [];

      var renderPageToBlob = async function(page, pg, pageEls, scale) {
        var vp = page.getViewport({ scale: scale, rotation: pg.rotation || 0 });
        var cvs = document.createElement("canvas");
        cvs.width = vp.width;
        cvs.height = vp.height;
        var ctx = cvs.getContext("2d");
        await page.render({ canvasContext: ctx, viewport: vp }).promise;

        // 오버레이 요소 그리기
        var cw = cvs.width, ch = cvs.height;
        var imgPromises = [];
        for (var j = 0; j < pageEls.length; j++) {
          var el = pageEls[j];
          var ex = (el.x / 100) * cw;
          var ey = (el.y / 100) * ch;
          var ew = (el.w / 100) * cw;
          var eh = (el.h / 100) * ch;

          if (el.type === "image" && el.src) {
            imgPromises.push((function(src, bx, by, bw, bh, rot) {
              return new Promise(function(resolve) {
                var img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = function() {
                  // 미리보기(object-fit:contain)와 동일하게 비율 유지로 그려 가로 눌림 방지
                  var iw = img.naturalWidth || bw, ih = img.naturalHeight || bh;
                  var ir = iw / ih, br = bw / bh;
                  var dw2, dh2, dx2, dy2;
                  if (ir > br) { dw2 = bw; dh2 = bw / ir; dx2 = bx; dy2 = by + (bh - dh2) / 2; }
                  else { dh2 = bh; dw2 = bh * ir; dy2 = by; dx2 = bx + (bw - dw2) / 2; }
                  var SIG_SCALE = 0.95;
                  var tw = Math.max(1, Math.round(dw2 * SIG_SCALE)), th = Math.max(1, Math.round(dh2 * SIG_SCALE));
                  var srcDraw = img;
                  if (tw < dw2 && th < dh2) {
                    var tc = document.createElement("canvas"); tc.width = tw; tc.height = th;
                    tc.getContext("2d").drawImage(img, 0, 0, tw, th); srcDraw = tc;
                  }
                  if (rot) {
                    ctx.save(); ctx.translate(bx + bw / 2, by + bh / 2); ctx.rotate(rot * Math.PI / 180);
                    ctx.drawImage(srcDraw, -dw2 / 2, -dh2 / 2, dw2, dh2); ctx.restore();
                  } else { ctx.drawImage(srcDraw, dx2, dy2, dw2, dh2); }
                  if (srcDraw !== img) { srcDraw.width = 0; srcDraw.height = 0; }
                  resolve();
                };
                img.onerror = function() { resolve(); };
                img.src = src;
              });
            })(el.src, ex, ey, ew, eh, el.rotation || 0));
          } else if (el.type === "text" && el.text) {
            var fontSize = Math.max(12, ch * ((el.h || 5) / 100) * 0.55);
            ctx.fillStyle = "#000000";
            ctx.font = "bold " + fontSize + "px serif";
            ctx.textBaseline = "top";
            ctx.fillText(el.text, ex, ey);
          } else if (el.type === "check") {
            var checkSize = Math.max(12, ch * ((el.h || 5) / 100) * 0.55);
            ctx.fillStyle = "#000000";
            ctx.font = "bold " + checkSize + "px serif";
            ctx.textBaseline = "top";
            ctx.fillText("\u2713", ex, ey);
          }
        }
        if (imgPromises.length > 0) await Promise.all(imgPromises);

        if (scanFx) applyScanEffect(cvs);
        var blob = await new Promise(function(resolve) {
          cvs.toBlob(function(b) { resolve(b); }, "image/jpeg", scanFx ? 0.82 : 0.96);
        });
        cvs.width = 0; cvs.height = 0; // 캔버스 메모리 즉시 해제
        return blob;
      };

      for (var i = 0; i < vis.length; i++) {
        var pg = vis[i];
        var page = await pdfDoc.getPage(pg.origIdx + 1);
        var pageEls = elements[pg.origIdx] || [];
        var base1 = page.getViewport({ scale: 1, rotation: pg.rotation || 0 });
        // 배경 화질 우선(약 252DPI). toBlob가 null이면(캔버스 한도 초과) 해상도를 낮춰 자동 재시도
        var rscale = Math.max(1.7, Math.min(1.9, 1600 / base1.width));
        var blob = null;
        for (var attempt = 0; attempt < 5 && !blob; attempt++) {
          blob = await renderPageToBlob(page, pg, pageEls, rscale);
          if (!blob) rscale = Math.max(1.8, rscale * 0.72);
        }
        if (!blob) throw new Error("이미지 변환 실패 (페이지가 너무 큽니다)");
        blobs.push(blob);
      }

      var fd = new FormData();
      for (var k = 0; k < blobs.length; k++) {
        fd.append("pages", blobs[k], "page_" + k + ".jpg");
      }

      var token = localStorage.getItem("token") || "";
      var res = await fetch("/api/pdf-editor/merge-images", {
        method: "POST",
        headers: token ? { "Authorization": "Bearer " + token } : {},
        body: fd,
      });
      if (!res.ok) throw new Error("저장 실패");
      var resultBlob = await res.blob();
      if (onSaveBlob) {
        await onSaveBlob(resultBlob);
      } else {
        var url = URL.createObjectURL(resultBlob);
        var a = document.createElement("a");
        a.href = url;
        a.download = (fileName || "document").replace(".pdf", "") + ".pdf";
        a.click();
        URL.revokeObjectURL(url);
      }
      setHasChanges(false);
      showT("저장 완료");
      try { localStorage.removeItem(LS_PREFIX + (uploadId || "url")); } catch (e) { /* */ }
      if (onSaved) onSaved();
    } catch (e) {
      showT(e.message || "저장 실패");
    }
    setSaving(false);
  }

  /* ── 다운로드 (rasterize 후 다운로드) ── */
  async function handleDownload() {
    if (!pdfUrl) { showT("PDF가 로드되지 않았습니다"); return; }
    setSaving(true);
    try {
      // Fetch current PDF blob
      var resp = await fetch(pdfUrl);
      var pdfBlob = await resp.blob();

      // Build page config
      var vis = pages.filter(function(p) { return !p.deleted; });
      var pagesConfig = vis.map(function(p, i) {
        return { originalIndex: p.origIdx, rotation: p.rotation || 0, order: i };
      });

      var formData = new FormData();
      formData.append("pdf", pdfBlob, "input.pdf");
      formData.append("pages", JSON.stringify(pagesConfig));
      formData.append("elements", JSON.stringify(elements));

      var token = localStorage.getItem("token") || "";
      var result = await fetch("/api/pdf-editor/render", {
        method: "POST",
        headers: token ? { "Authorization": "Bearer " + token } : {},
        body: formData,
      });

      if (!result.ok) throw new Error("렌더링 실패");

      var outBlob = await result.blob();
      var url = URL.createObjectURL(outBlob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "edited.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      showT("다운로드 완료");
      setSaving(false);
    } catch (e) {
      showT("다운로드 실패: " + e.message);
      setSaving(false);
    }
  }

  function handleClose() {
    if (hasChanges && !window.confirm("변경사항이 저장되지 않습니다. 닫으시겠습니까?")) return;
    onClose();
  }

  function deleteElement(elId) {
    var els = (elements[curOrigIdx] || []).filter(function(el) { return el.id !== elId; });
    updateElements(curOrigIdx, els);
    setSelectedEl(null);
  }

  /* ── 좌측 툴바 아이콘 ── */
  var tools = [
    { id: "signature", label: "서명", icon: '<path d="M17.5 2.5L21 6l-11.5 11.5H6v-3.5L17.5 2.5z"/>' },
    { id: "stamp", label: "도장", icon: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/>' },
  ];

  function handleToolClick(t) {
    if (t === "signature") { setShowSigModal(true); setTool(null); }
    else if (t === "stamp") { setShowStampModal(true); setTool(null); }
    else { setTool(tool === t ? null : t); }
  }

  /* ════════════════════════════════════════
     렌더
     ════════════════════════════════════════ */
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.65)", backdropFilter: "blur(4px)", zIndex: 99999, display: "flex", flexDirection: "column" }}>

      {/* ── 상단바 ── */}
      <div style={{ height: 48, background: P, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 16px", flexShrink: 0 }}>
        <span style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>PDF 편집기</span>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input ref={fileInputRef} type="file" accept=".pdf,application/pdf" style={{ display: "none" }} onChange={handleOpenPdf} />
          <button onClick={function() { fileInputRef.current && fileInputRef.current.click(); }} style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid rgba(255,255,255,.3)", background: "rgba(255,255,255,.12)", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 14 }}>📂</span> PDF 열기
          </button>
          <button onClick={function() { handleSave(false); }} disabled={saving || !pdfUrl} style={{ padding: "6px 14px", borderRadius: 6, border: "none", background: saving ? G[400] : OK, color: "#fff", fontSize: 12, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", marginRight: 6 }}>
            {saving ? "처리 중..." : "PDF 다운로드"}
          </button>
          {!hideScan && (
          <button onClick={function() { handleSave(true); }} disabled={saving || !pdfUrl} title="스캔한 것처럼 노이즈·기울기 적용 (글자추출 방지)" style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid " + OK, background: "#fff", color: OK, fontSize: 12, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer" }}>
            스캔본 다운로드
          </button>
          )}
          <button onClick={handleClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}>
            <Svg d={iX} s={20} c="#fff" />
          </button>
        </div>
      </div>

      {/* ── 메인 영역 ── */}
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

        {/* ── 좌측 도구 ── */}
        <div style={{ width: 64, background: "#1F2937", display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 12, gap: 4, flexShrink: 0 }}>
          {tools.map(function(t) {
            var active = tool === t.id;
            return (
              <button key={t.id} onClick={function() { handleToolClick(t.id); }} title={t.label}
                style={{ width: 52, height: 52, border: "none", borderRadius: 8, background: active ? A : "transparent", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, transition: "background .15s" }}
                onMouseEnter={function(e) { if (!active) e.currentTarget.style.background = "rgba(255,255,255,.1)"; }}
                onMouseLeave={function(e) { if (!active) e.currentTarget.style.background = "transparent"; }}>
                <Svg d={t.icon} s={18} c={active ? "#fff" : G[400]} />
                <span style={{ fontSize: 9, color: active ? "#fff" : G[400] }}>{t.label}</span>
              </button>
            );
          })}
        </div>

        {/* ── 캔버스 영역 ── */}
        <div ref={containerRef} style={{ flex: 1, overflow: "auto", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: 20, background: G[100], cursor: tool === "text" || tool === "check" ? "crosshair" : "default" }}
          onDragOver={!pdfUrl ? function(e) { e.preventDefault(); } : undefined}
          onDrop={!pdfUrl ? function(e) {
            e.preventDefault();
            var file = e.dataTransfer.files && e.dataTransfer.files[0];
            if (!file || file.type !== "application/pdf") return;
            setFileName(file.name);
            var blobUrl = URL.createObjectURL(file);
            setPdfUrl(blobUrl);
            setLoading(true);
            setPages([]);
            setPageImages({});
            setElements({});
            setSelectedEl(null);
            setCurPage(0);
            setHasChanges(false);
          } : undefined}
        >
          {!pdfUrl ? (
            <div style={{ textAlign: "center", padding: 80, color: G[400], display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke={G[300]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              <div style={{ fontSize: 18, fontWeight: 700, color: G[600] }}>PDF 파일을 불러오세요</div>
              <div style={{ fontSize: 13, color: G[400], lineHeight: 1.6 }}>파일을 이 영역에 드래그하거나 PDF 열기 버튼을 클릭하세요</div>
              <button onClick={function() { fileInputRef.current && fileInputRef.current.click(); }} style={{ marginTop: 8, padding: "10px 28px", background: A, color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>PDF 열기</button>
            </div>
          ) : loading ? (
            <div style={{ textAlign: "center", padding: 60, color: G[400], fontSize: 14 }}>PDF 로딩 중...</div>
          ) : (
            <div style={{ position: "relative", display: "inline-block" }}>
              <canvas ref={canvasRef} onClick={handleCanvasClick} style={{ display: "block", boxShadow: "0 4px 20px rgba(0,0,0,.15)", borderRadius: 2, background: "#fff" }} />
              <RulerOverlay />

              {/* ── 오버레이 요소들 ── */}
              {curElements.map(function(el) {
                var isSelected = selectedEl === el.id;
                var elStyle = {
                  position: "absolute",
                  left: el.x + "%",
                  top: el.y + "%",
                  width: el.w ? el.w + "%" : "auto",
                  height: el.h ? el.h + "%" : "auto",
                  border: isSelected ? "2px solid " + A : "1px dashed transparent",
                  cursor: "move",
                  userSelect: "none",
                  boxSizing: "border-box",
                  zIndex: isSelected ? 10 : 1,
                };
                return (
                  <div key={el.id} style={elStyle} onMouseDown={function(e) { if (!el.editing) handleElMouseDown(e, el.id); }}>
                    {el.type === "image" && <img src={el.src} alt="" draggable={false} style={{ width: "100%", height: "100%", objectFit: "contain", pointerEvents: "none", transform: el.rotation ? "rotate(" + el.rotation + "deg)" : undefined }} />}
                    {el.type === "text" && (el.editing ? (
                      <textarea autoFocus
                        defaultValue={el.text}
                        onBlur={function(ev) {
                          var val = ev.target.value;
                          if (!val.trim()) { deleteElement(el.id); return; }
                          var els = (elements[curOrigIdx] || []).map(function(x) { return x.id === el.id ? Object.assign({}, x, { text: val, editing: false }) : x; });
                          updateElements(curOrigIdx, els);
                        }}
                        onKeyDown={function(ev) { if (ev.key === "Enter" && !ev.shiftKey) { ev.preventDefault(); ev.target.blur(); } }}
                        style={{ width: "100%", height: "100%", fontSize: Math.max(10, canvasSize.h * (el.h || 4) / 100 * 0.6), color: "#000", border: "1px solid " + A, borderRadius: 2, padding: 2, resize: "none", outline: "none", background: "rgba(255,255,255,.9)", fontFamily: "inherit", boxSizing: "border-box" }} />
                    ) : (
                      <div onDoubleClick={function() {
                        var els = (elements[curOrigIdx] || []).map(function(x) { return x.id === el.id ? Object.assign({}, x, { editing: true }) : x; });
                        updateElements(curOrigIdx, els);
                      }} style={{ fontSize: Math.max(10, canvasSize.h * (el.h || 4) / 100 * 0.6), color: "#000", whiteSpace: "nowrap", lineHeight: 1.2, pointerEvents: "auto", padding: 2, cursor: "move" }}>{el.text}</div>
                    ))}
                    {el.type === "check" && <div style={{ fontSize: Math.max(12, canvasSize.h * (el.h || 3) / 100 * 0.7), color: "#000", lineHeight: 1, pointerEvents: "none", textAlign: "center", fontWeight: "bold" }}>{"\u2713"}</div>}

                    {/* 회전 핸들 (도장 정방향) */}
                    {isSelected && el.type === "image" && <div onMouseDown={function(e) { handleRotateDown(e, el.id); }} title="드래그로 회전" style={{ position: "absolute", top: -28, left: "50%", transform: "translateX(-50%)", width: 18, height: 18, borderRadius: 9, background: "#fff", border: "2px solid " + A, cursor: "grab", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11 }}>{"\u21BB"}</div>}
                    {/* 리사이즈 핸들 */}
                    {isSelected && <div onMouseDown={function(e) { handleResizeDown(e, el.id); }} style={{ position: "absolute", right: -4, bottom: -4, width: 8, height: 8, background: A, cursor: "nwse-resize", borderRadius: 1 }} />}
                    {/* 삭제 버튼 */}
                    {isSelected && <button onClick={function(e) { e.stopPropagation(); deleteElement(el.id); }} style={{ position: "absolute", top: -10, right: -10, width: 18, height: 18, borderRadius: 9, background: E, color: "#fff", border: "none", fontSize: 10, cursor: "pointer", lineHeight: "18px", textAlign: "center", padding: 0 }}>x</button>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* ── 하단 썸네일 스트립 ── */}
      {pdfUrl && visiblePages.length > 0 && (
        <div style={{ flexShrink: 0 }}>
          {/* 리사이즈 핸들 */}
          <div
            style={{ height: 8, background: "#374151", cursor: "ns-resize", display: "flex", alignItems: "center", justifyContent: "center" }}
            onMouseDown={function(e) {
              e.preventDefault();
              var startY = e.clientY;
              var startH = stripHeight;
              function onMove(ev) {
                var diff = startY - ev.clientY;
                var newH = Math.max(80, Math.min(400, startH + diff));
                setStripHeight(newH);
              }
              function onUp() {
                document.removeEventListener("mousemove", onMove);
                document.removeEventListener("mouseup", onUp);
              }
              document.addEventListener("mousemove", onMove);
              document.addEventListener("mouseup", onUp);
            }}
          >
            <div style={{ width: 32, height: 2, background: "#6B7280", borderRadius: 1 }} />
            <div style={{ width: 32, height: 2, background: "#6B7280", borderRadius: 1, marginLeft: 2 }} />
          </div>
          <div style={{ height: stripHeight, background: "#1F2937", borderTop: "1px solid " + G[700], display: "flex", alignItems: "center", padding: "0 12px", gap: 8, overflowX: "auto", overflowY: "hidden" }}>
            {visiblePages.map(function(pg, vi) {
              var isOver = thumbOver === vi && thumbDrag !== vi;
              var isCur = curPage === vi;
              var thumbW = Math.max(60, stripHeight * 0.6);
              return (
                <div key={"ts" + pg.origIdx}
                  draggable
                  onDragStart={function() { setThumbDrag(vi); }}
                  onDragOver={function(e) { e.preventDefault(); setThumbOver(vi); }}
                  onDrop={function() { handleThumbDrop(vi); }}
                  onDragEnd={function() { setThumbDrag(null); setThumbOver(null); }}
                  onClick={function() { setCurPage(vi); }}
                  style={{
                    flexShrink: 0, cursor: "grab", position: "relative",
                    width: thumbW,
                    opacity: thumbDrag === vi ? 0.3 : 1,
                    border: isOver ? "2px solid " + A : isCur ? "2px solid " + A : "2px solid transparent",
                    borderRadius: 4, padding: 1, background: isCur ? "rgba(46,117,182,.25)" : "transparent",
                    transition: "all .12s"
                  }}>
                  {/* 회전/삭제 버튼 */}
                  <div style={{ position: "absolute", top: 4, right: 4, display: "flex", gap: 2, zIndex: 2 }}>
                    <button onClick={function(e) { e.stopPropagation(); rotatePage(pages.indexOf(pg)); }} style={{ background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 20, height: 20, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>{"\u21BB"}</button>
                    <button onClick={function(e) { e.stopPropagation(); deletePage(pg.origIdx); }} style={{ background: "rgba(220,38,38,0.8)", color: "white", border: "none", borderRadius: "50%", width: 20, height: 20, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>{"\u00D7"}</button>
                  </div>
                  {pageImages[pg.origIdx] ? (
                    <img src={pageImages[pg.origIdx]} alt="" style={{ height: stripHeight - 36, width: "100%", objectFit: "contain", display: "block", borderRadius: 3 }} />
                  ) : (
                    <div style={{ width: "100%", height: stripHeight - 36, background: G[600], borderRadius: 3 }} />
                  )}
                  <div style={{ textAlign: "center", fontSize: 9, color: isCur ? "#fff" : G[400], marginTop: 2 }}>{vi + 1}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── 서명 모달 ── */}
      {showSigModal && <SignatureModal onDone={function(src) { setShowSigModal(false); if (src) addImageElement(src); }} />}

      {/* ── 도장 모달 ── */}
      {showStampModal && <StampModal onDone={function(src) { setShowStampModal(false); if (src) addImageElement(src); }} />}

      <Toast msg={toast} />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════
   서명 모달 (그리기 전용 — 펜 필압 지원)
   ════════════════════════════════════════════════════════════════ */
function SignatureModal({ onDone }) {
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.5)", zIndex: 100001, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={function() { onDone(null); }}>
      <div onClick={function(e) { e.stopPropagation(); }} style={{ background: "#fff", borderRadius: 14, width: 460, maxWidth: "95vw", maxHeight: "85vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ padding: "16px 20px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: G[900] }}>서명 — 펜으로 직접 그리세요</h3>
          <button onClick={function() { onDone(null); }} style={{ background: "none", border: "none", cursor: "pointer" }}><Svg d={iX} s={18} c={G[400]} /></button>
        </div>
        <div style={{ padding: 20 }}>
          <DrawTab onDone={onDone} />
        </div>
      </div>
    </div>
  );
}

/* ── 그리기 탭 (고해상도 + 펜 필압 + 곡선 스무딩) ── */
function DrawTab({ onDone }) {
  var SCALE = 3; // 백킹 해상도 배율 (계단현상 방지)
  var cRef = useRef(null);
  var drawingRef = useRef(false);
  var ptsRef = useRef([]);      // 현재 획 점들 [{x,y,p}]
  var strokesRef = useRef([]);  // 완료된 획들
  var historyRef = useRef([]);
  var [color, setColor] = useState("#000");
  var [thickness, setThickness] = useState(2);

  // 표시 크기에 맞춰 백킹 해상도를 SCALE배로 설정
  useEffect(function() {
    var cvs = cRef.current;
    if (!cvs) return;
    var r = cvs.getBoundingClientRect();
    if (r.width && r.height) { cvs.width = Math.round(r.width * SCALE); cvs.height = Math.round(r.height * SCALE); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getPos(e) {
    var cvs = cRef.current;
    var r = cvs.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (cvs.width / r.width), y: (e.clientY - r.top) * (cvs.height / r.height) };
  }
  function pressureOf(e) {
    return (e.pointerType === "pen" && typeof e.pressure === "number" && e.pressure > 0) ? e.pressure : null;
  }
  function widthFor(pr) {
    var base = thickness * SCALE;
    if (pr == null) return base;            // 마우스/손가락: 슬라이더 굵기 고정
    return Math.max(0.5 * SCALE, base * (0.3 + pr * 1.6)); // 펜: 필압으로 가변
  }
  function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }

  function seg(ctx, from, ctrl, to, w) {
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    if (ctrl) ctx.quadraticCurveTo(ctrl.x, ctrl.y, to.x, to.y);
    else ctx.lineTo(to.x, to.y);
    ctx.lineWidth = w;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = color;
    ctx.stroke();
  }
  function dot(ctx, p) {
    ctx.beginPath();
    ctx.arc(p.x, p.y, widthFor(p.p) / 2, 0, Math.PI * 2);
    ctx.fillStyle = color;
    ctx.fill();
  }

  function onDown(e) {
    e.preventDefault();
    try { cRef.current.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
    drawingRef.current = true;
    var p = getPos(e); p.p = pressureOf(e);
    ptsRef.current = [p];
  }
  function onMove(e) {
    if (!drawingRef.current) return;
    e.preventDefault();
    var ctx = cRef.current.getContext("2d");
    var p = getPos(e); p.p = pressureOf(e);
    var pts = ptsRef.current;
    pts.push(p);
    var n = pts.length;
    if (n === 2) seg(ctx, pts[0], null, pts[1], widthFor(pts[1].p));
    else if (n >= 3) { var a = pts[n - 3], b = pts[n - 2], c = pts[n - 1]; seg(ctx, mid(a, b), b, mid(b, c), widthFor(b.p)); }
  }
  function onUp(e) {
    if (drawingRef.current && ptsRef.current.length) {
      var ctx = cRef.current.getContext("2d");
      var pts = ptsRef.current;
      var n = pts.length;
      if (n >= 2) seg(ctx, mid(pts[n - 2], pts[n - 1]), pts[n - 1], pts[n - 1], widthFor(pts[n - 1].p));
      else dot(ctx, pts[0]);
      strokesRef.current.push(pts.slice());
    }
    drawingRef.current = false;
    ptsRef.current = [];
    historyRef.current = [];
    try { if (e && e.pointerId != null) cRef.current.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
  }

  function redrawAll() {
    var cvs = cRef.current;
    var ctx = cvs.getContext("2d");
    ctx.clearRect(0, 0, cvs.width, cvs.height);
    strokesRef.current.forEach(function(pts) {
      var n = pts.length;
      if (n === 1) { dot(ctx, pts[0]); return; }
      seg(ctx, pts[0], null, pts[1], widthFor(pts[1].p));
      for (var i = 2; i < n; i++) seg(ctx, mid(pts[i - 2], pts[i - 1]), pts[i - 1], mid(pts[i - 1], pts[i]), widthFor(pts[i - 1].p));
      seg(ctx, mid(pts[n - 2], pts[n - 1]), pts[n - 1], pts[n - 1], widthFor(pts[n - 1].p));
    });
  }

  function clearCanvas() {
    historyRef.current = strokesRef.current.slice();
    strokesRef.current = [];
    redrawAll();
  }
  function redo() {
    if (historyRef.current.length === 0) return;
    strokesRef.current = historyRef.current.slice();
    historyRef.current = [];
    redrawAll();
  }
  function confirm() { onDone(cRef.current.toDataURL("image/png")); }

  return (
    <div>
      <canvas ref={cRef} width={1200} height={480}
        onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerLeave={onUp} onPointerCancel={onUp}
        style={{ border: "1px solid " + G[200], borderRadius: 8, cursor: "crosshair", display: "block", width: "100%", height: 160, background: "#fff", touchAction: "none" }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          {PEN_COLORS.map(function(c) {
            return <button key={c} onClick={function() { setColor(c); }} style={{ width: 22, height: 22, borderRadius: 11, background: c, border: color === c ? "3px solid " + A : "2px solid " + G[200], cursor: "pointer" }} />;
          })}
          <input type="range" min="1" max="6" value={thickness} onChange={function(e) { setThickness(Number(e.target.value)); }} style={{ width: 60, marginLeft: 8 }} />
          <span style={{ fontSize: 10, color: G[500] }}>굵기 {thickness} · 펜 필압</span>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button onClick={clearCanvas} style={{ padding: "4px 10px", border: "1px solid " + G[200], borderRadius: 6, background: "#fff", fontSize: 11, cursor: "pointer", color: G[600] }}>지우기</button>
          <button onClick={redo} style={{ padding: "4px 10px", border: "1px solid " + G[200], borderRadius: 6, background: "#fff", fontSize: 11, cursor: "pointer", color: G[600] }}>되돌리기</button>
        </div>
      </div>
      <button onClick={confirm} style={{ marginTop: 14, width: "100%", padding: "10px 0", borderRadius: 8, border: "none", background: A, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>서명 적용</button>
    </div>
  );
}

/* ── 서명글자 탭 (미사용: 서명 모달을 그리기 전용으로 전환) ── */
// eslint-disable-next-line no-unused-vars
function FontTab({ onDone }) {
  var [name, setName] = useState("");
  var display = name || "홍길동";

  function handleSelect(idx) {
    if (!name.trim()) return;
    var src = renderTextToCanvas(name, FONT_STYLES[idx], 40, "#000");
    onDone(src);
  }

  return (
    <div>
      <input value={name} onChange={function(e) { setName(e.target.value); }} placeholder="이름 입력" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid " + G[200], borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 12, outline: "none" }} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
        {FONT_STYLES.map(function(f, i) {
          return (
            <button key={i} onClick={function() { handleSelect(i); }}
              style={{ padding: "16px 8px", border: "1.5px solid " + G[200], borderRadius: 8, background: "#fff", cursor: name.trim() ? "pointer" : "not-allowed", textAlign: "center", transition: "border .15s", minHeight: 60 }}
              onMouseEnter={function(e) { if (name.trim()) e.currentTarget.style.borderColor = A; }}
              onMouseLeave={function(e) { e.currentTarget.style.borderColor = G[200]; }}>
              <span style={{ fontFamily: f.family, fontWeight: f.weight, fontStyle: f.style, fontSize: 20, color: "#000", display: "block" }}>{display}</span>
              <span style={{ fontSize: 9, color: G[400], marginTop: 4, display: "block" }}>{f.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* ── 업로드 탭 (드래그앤드롭 지원) ── */
function UploadTab({ onDone }) {
  var [drag, setDrag] = useState(false);
  function readFile(file) {
    if (!file || !/^image\//.test(file.type)) return;
    var reader = new FileReader();
    reader.onload = function(ev) { onDone(ev.target.result); };
    reader.readAsDataURL(file);
  }
  return (
    <div style={{ textAlign: "center", padding: "20px 0" }}>
      <div style={{ fontSize: 13, color: G[500], marginBottom: 16 }}>서명/도장 이미지를 업로드하세요 (PNG/JPG)</div>
      <label
        onDragOver={function(e) { e.preventDefault(); setDrag(true); }}
        onDragLeave={function(e) { e.preventDefault(); setDrag(false); }}
        onDrop={function(e) { e.preventDefault(); setDrag(false); readFile(e.dataTransfer.files[0]); }}
        style={{ display: "block", padding: "28px 24px", borderRadius: 10, border: "2px dashed " + (drag ? A : G[300]), background: drag ? "#EFF6FF" : G[50], cursor: "pointer", fontSize: 13, color: A, fontWeight: 600, transition: "all .15s" }}>
        {drag ? "여기에 놓으세요" : "파일 선택 또는 여기로 드래그"}
        <input type="file" accept="image/*" onChange={function(e) { readFile(e.target.files[0]); }} style={{ display: "none" }} />
      </label>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════
   도장 모달 (3탭: 일반도장, 법인도장, 업로드) + 저장된 도장
   ════════════════════════════════════════════════════════════════ */
// 저장된 도장 — 공용 보관함(stampStore: 30개 · 보관 사본 축소 · 넘치면 오래된 것부터, 2026-10-31)

function StampModal({ onDone }) {
  var [saved, setSaved] = useState(getSavedStamps);

  function handleDone(src) {
    if (src) saveStamp(src).then(setSaved).catch(function() { /* 저장소 막힘 — 넣기는 그대로 */ });
    onDone(src);
  }
  function handleDeleteSaved(id) { setSaved(deleteStamp(id)); }
  function handleRename(id, name) { setSaved(renameStamp(id, name)); }

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.5)", zIndex: 100001, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={function() { onDone(null); }}>
      <div onClick={function(e) { e.stopPropagation(); }} style={{ background: "#fff", borderRadius: 14, width: 440, maxWidth: "95vw", maxHeight: "85vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ padding: "16px 20px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: G[900] }}>도장 업로드</h3>
          <button onClick={function() { onDone(null); }} style={{ background: "none", border: "none", cursor: "pointer" }}><Svg d={iX} s={18} c={G[400]} /></button>
        </div>
        <div style={{ padding: 20 }}>
          <UploadTab onDone={handleDone} />
        </div>
        {saved.length > 0 && (
          <div style={{ padding: "0 20px 16px" }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: G[500], marginBottom: 8, borderTop: "1px solid " + G[200], paddingTop: 12 }}>저장된 도장</div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {saved.map(function(s) {
                return (
                  <div key={s.id} style={{ position: "relative", width: 72, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                    <button onClick={function() { onDone(s.data); }}
                      style={{ width: 64, height: 64, padding: 4, border: "1.5px solid " + G[200], borderRadius: 8, background: "#fff", cursor: "pointer", transition: "border-color 0.15s" }}
                      onMouseEnter={function(e) { e.currentTarget.style.borderColor = A; }}
                      onMouseLeave={function(e) { e.currentTarget.style.borderColor = G[200]; }}>
                      <img src={s.data} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                    </button>
                    <button onClick={function(e) { e.stopPropagation(); handleDeleteSaved(s.id); }}
                      style={{ position: "absolute", top: -6, right: -6, width: 18, height: 18, borderRadius: 9, border: "none", background: G[400], color: "#fff", fontSize: 11, lineHeight: "18px", textAlign: "center", cursor: "pointer", padding: 0 }}>×</button>
                    <input value={s.name || ""} onChange={function(e) { handleRename(s.id, e.target.value); }} onClick={function(e) { e.stopPropagation(); }} placeholder="도장 이름"
                      style={{ width: 70, fontSize: 10, padding: "2px 4px", border: "1px solid " + G[200], borderRadius: 4, textAlign: "center", outline: "none", boxSizing: "border-box", color: G[700] }} />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ── 일반도장 탭 ── */
function GeneralStampTab({ onDone }) {
  var [name, setName] = useState("");
  var display = name || "로움";

  return (
    <div>
      <input value={name} onChange={function(e) { setName(e.target.value); }} placeholder="회사명 입력" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid " + G[200], borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 12, outline: "none" }} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
        {[0, 1, 2, 3, 4, 5, 6, 7].map(function(s) {
          var src = renderStampSVG(display, s);
          return (
            <button key={s} onClick={function() { if (name.trim()) onDone(src); }}
              style={{ padding: 8, border: "1.5px solid " + G[200], borderRadius: 8, background: "#fff", cursor: name.trim() ? "pointer" : "not-allowed", textAlign: "center", transition: "border-color 0.15s" }}
              onMouseEnter={function(e) { if (name.trim()) e.currentTarget.style.borderColor = "#CC0000"; }}
              onMouseLeave={function(e) { e.currentTarget.style.borderColor = G[200]; }}>
              <img src={src} alt="" style={{ width: 72, height: 72 }} />
            </button>
          );
        })}
      </div>
      {!name.trim() && <div style={{ textAlign: "center", fontSize: 11, color: G[400], marginTop: 8 }}>이름을 입력하면 도장이 활성화됩니다</div>}
    </div>
  );
}

/* ── 법인도장 탭 ── */
function CorpStampTab({ onDone }) {
  var [name, setName] = useState("");
  var display = name || "주식회사";

  return (
    <div>
      <input value={name} onChange={function(e) { setName(e.target.value); }} placeholder="법인명 입력 (예: 주식회사 로움)" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid " + G[200], borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 12, outline: "none" }} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
        {[0, 1, 2, 3, 4, 5, 6, 7].map(function(s) {
          var src = renderCorpStamp(display, s);
          return (
            <button key={s} onClick={function() { if (name.trim()) onDone(src); }}
              style={{ padding: 8, border: "1.5px solid " + G[200], borderRadius: 8, background: "#fff", cursor: name.trim() ? "pointer" : "not-allowed", textAlign: "center", transition: "border-color 0.15s" }}
              onMouseEnter={function(e) { if (name.trim()) e.currentTarget.style.borderColor = "#CC0000"; }}
              onMouseLeave={function(e) { e.currentTarget.style.borderColor = G[200]; }}>
              <img src={src} alt="" style={{ width: 72, height: 72 }} />
            </button>
          );
        })}
      </div>
      {!name.trim() && <div style={{ textAlign: "center", fontSize: 11, color: G[400], marginTop: 8 }}>법인명을 입력하면 도장이 활성화됩니다</div>}
    </div>
  );
}
